import { MOBILE_TABLET_BREAKPOINT } from "../constant/constants";

export const isMobileScreen = (width: number): boolean =>
  width <= MOBILE_TABLET_BREAKPOINT;

export const getWindowWidth = (): number =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;
